/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MnSubLnbData model module.
 * @module model/MnSubLnbData
 * @version 1.0
 */
class MnSubLnbData {
    /**
     * Constructs a new <code>MnSubLnbData</code>.
     * @alias module:model/MnSubLnbData
     */
    constructor() { 
        
        MnSubLnbData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MnSubLnbData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MnSubLnbData} obj Optional instance to populate.
     * @return {module:model/MnSubLnbData} The populated <code>MnSubLnbData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MnSubLnbData();

            if (data.hasOwnProperty('gnbNo')) {
                obj['gnbNo'] = ApiClient.convertToType(data['gnbNo'], 'Number');
            }
            if (data.hasOwnProperty('lnbNo')) {
                obj['lnbNo'] = ApiClient.convertToType(data['lnbNo'], 'Number');
            }
            if (data.hasOwnProperty('subNo')) {
                obj['subNo'] = ApiClient.convertToType(data['subNo'], 'Number');
            }
            if (data.hasOwnProperty('subName')) {
                obj['subName'] = ApiClient.convertToType(data['subName'], 'String');
            }
            if (data.hasOwnProperty('pageUrl')) {
                obj['pageUrl'] = ApiClient.convertToType(data['pageUrl'], 'String');
            }
            if (data.hasOwnProperty('sort')) {
                obj['sort'] = ApiClient.convertToType(data['sort'], 'Number');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MnSubLnbData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MnSubLnbData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['subName'] && !(typeof data['subName'] === 'string' || data['subName'] instanceof String)) {
            throw new Error("Expected the field `subName` to be a primitive type in the JSON string but got " + data['subName']);
        }
        // ensure the json data is a string
        if (data['pageUrl'] && !(typeof data['pageUrl'] === 'string' || data['pageUrl'] instanceof String)) {
            throw new Error("Expected the field `pageUrl` to be a primitive type in the JSON string but got " + data['pageUrl']);
        }

        return true;
    }


}



/**
 * @member {Number} gnbNo
 */
MnSubLnbData.prototype['gnbNo'] = undefined;

/**
 * @member {Number} lnbNo
 */
MnSubLnbData.prototype['lnbNo'] = undefined;

/**
 * @member {Number} subNo
 */
MnSubLnbData.prototype['subNo'] = undefined;

/**
 * @member {String} subName
 */
MnSubLnbData.prototype['subName'] = undefined;

/**
 * @member {String} pageUrl
 */
MnSubLnbData.prototype['pageUrl'] = undefined;

/**
 * @member {Number} sort
 */
MnSubLnbData.prototype['sort'] = undefined;

/**
 * @member {Boolean} enabled
 */
MnSubLnbData.prototype['enabled'] = undefined;






export default MnSubLnbData;

